import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IScheduleFilter, schedulesList, schedulesListWithCompound } from '../../interfaces/IScheduleFilter';
import { Store } from '@ngxs/store';
import { PharmacyState } from '../../states/pharmacy/pharmacy.state';
import { DrugScheduleEnum } from '../../interfaces/DrugScheduleEnum ';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged } from 'rxjs/operators';
import { DrugActivitiesToTrackEnum } from '../../interfaces/DrugActivitiesToTrackEnum';
@UntilDestroy()
@Component({
  selector: 'app-schedules-filter',
  templateUrl: './schedules-filter.component.html',
  styleUrls: ['./schedules-filter.component.scss'],
})
export class SchedulesFilterComponent implements OnInit {
  @Input() control: UntypedFormControl;
  @Input() label: string;
  @Input() selectedItemsBadgeLimitCount = 3;

  schedulesList: IScheduleFilter[] = [...schedulesList];

  schedulesListSettings = {
    selectAllText: 'All Schedules',
    unSelectAllText: 'Deselect All',
    allowSearchFilter: false,
    searchPlaceholderText: 'Search Schedules',
    noDataAvailablePlaceholderText: 'No schedules available',
    enableCheckAll: false,
    badgeAlias: 'badgeAlias',
    maxHeight: 220
  };

  constructor(private cd: ChangeDetectorRef, private store: Store) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.cd.detectChanges();
    }, 50);
    if (this.store.selectSnapshot(PharmacyState.compoundingEnabled)) {
      this.schedulesList = schedulesListWithCompound;
    }

   this.store.select(PharmacyState.enableC3toC5Drugs)
   .pipe(untilDestroyed(this), distinctUntilChanged())
   .subscribe(enabled => {
    if (enabled && !this.schedulesList.map(x => x.id).includes(DrugScheduleEnum.CAList)) {
      this.schedulesList.push(
        { id: DrugScheduleEnum.CAList, name: 'CA List', badgeAlias: 'CA List' },
      )
    }
   })
  }

  isAllItemsSelected(): boolean {
    if (this.control?.value) {
      return this.control.value.length === this.schedulesList.length;
    }
    return true;
  }
}
